export function obtenerBytesBase64Archivos(event, _this) {
    let laPromesa = function (archivo) {
        return new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.onload = function () {
                var arrayBuffer = this.result;                
                var base64Data = btoa(arrayBuffer);
                resolve(base64Data);
            };
            reader.readAsBinaryString(archivo);
        });
    }

    let archivo = event.target.files[0];
    let nombrePropiedad = event.target.name;
    let arregloDivisionNombre = nombrePropiedad.split(".");
    laPromesa(archivo).then(resultado => {        
        let nombreObjetoState = arregloDivisionNombre[0];
        let nombreAtributoObjetoState = arregloDivisionNombre[1];
        let objeto = _this.state[nombreObjetoState];
        objeto[nombreAtributoObjetoState] = resultado;
        objeto["nombreArchivo_" + nombreAtributoObjetoState] = archivo.name;        
        _this.setState({ objeto });
    });
}


export function obtenerObjetoBase64Archivos(objetoAsignar,file) {
    let laPromesa = function (archivo) {
        return new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.onload = function () {
                var arrayBuffer = this.result;                
                var base64Data = btoa(arrayBuffer);
                resolve(base64Data);
            };
            reader.readAsBinaryString(archivo);
        });
    }

    let archivo = file;
    laPromesa(archivo).then(resultado => {
        objetoAsignar.stringBase64 = resultado;
        objetoAsignar.nombre = archivo.name;        
    });
}


export function obtenerObjetoBase64Archivos2023(objetoAsignar,archivo) {
        return new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.onload = function () {
                var arrayBuffer = this.result;                
                var base64Data = btoa(arrayBuffer);
                objetoAsignar.stringBase64 = base64Data;
                objetoAsignar.nombre = archivo.name;       
                resolve(objetoAsignar);
            };
            reader.readAsBinaryString(archivo);
        });
    
}